import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { SmoothScrollProvider } from "@/lib/smooth-scroll";
import { Nav } from "@/components/inkwell/Nav";
import { Hero } from "@/components/inkwell/Hero";
import { Work } from "@/components/inkwell/Work";
import { About } from "@/components/inkwell/About";
import { FilmPrelude } from "@/components/inkwell/FilmPrelude";
import { AtLast } from "@/components/inkwell/AtLast";
import { SwimDivider } from "@/components/inkwell/SwimDivider";
import { Insurance } from "@/components/inkwell/Insurance";
import { Papers } from "@/components/inkwell/Papers";
import { Transition } from "@/components/inkwell/Transition";
import { Contact } from "@/components/inkwell/Contact";
import { Journal } from "@/components/inkwell/Journal";
import { Begin } from "@/components/inkwell/Begin";
import { Footer } from "@/components/inkwell/Footer";
import PaperReader from "@/pages/PaperReader";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Home() {
  return (
    <>
      <a
        href="#work"
        data-testid="skip-to-content-link"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[90] focus:rounded-sm focus:bg-gold focus:px-5 focus:py-2 focus:text-sm focus:text-inkblack"
      >
        Skip to content
      </a>
      <Nav />
      <main>
        <Hero />
        <Work />
        <About />
        <FilmPrelude />
        <Journal />
        <AtLast />
        <SwimDivider />
        <Insurance />
        <Papers />
        <Transition />
        <Contact />
        <Begin />
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <SmoothScrollProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen bg-inkblack text-ivory">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/papers/:id" element={<PaperReader />} />
          </Routes>
          <Toaster
            theme="dark"
            position="bottom-center"
            toastOptions={{
              style: {
                background: "oklch(0.2 0.008 110)",
                border: "1px solid oklch(0.64 0.075 75 / 0.35)",
                color: "oklch(0.95 0.015 85)",
              },
            }}
          />
        </div>
      </BrowserRouter>
    </SmoothScrollProvider>
  );
}
